export enum ReportReason {
  NOT_APPROPRIATE = 'not_appropriate',
  SPAM = 'spam',
}
